import { RootState, StoreState } from "@store/store";

export type AccountState = {
  account: any | null;
  oldStripeData: any | null;
  setOldStripeData: (data: any) => void;
  setAccountData: (data: any) => void;
  setCreditBalance: (balance: number) => void;
  setCreditMax: (max: number) => void;
};

export const createAccountSlice: StoreState<AccountState> = (set) => ({
  account: null,
  oldStripeData: null,

  setOldStripeData: (data) => {
    set(({ accountDataState }) => {
      accountDataState.oldStripeData = data;
    });
  },

  setAccountData: (data) => {
    set(({ accountDataState }) => {
      accountDataState.account = data;
    });
  },

  setCreditBalance: (balance) => {
    set(({ accountDataState }) => {
      accountDataState.account.creditBalance = balance;
    });
  },

  setCreditMax: (max) => {
    set(({ accountDataState }) => {
      accountDataState.account.creditMax = max;
    });
  },
});

export const selectAccountDataActions = (state: RootState) => ({
  setAccountData: state.accountDataState.setAccountData,
  setCreditBalance: state.accountDataState.setCreditBalance,
  setCreditMax: state.accountDataState.setCreditMax,
  setOldStripeData: state.accountDataState.setOldStripeData,
});

export const selectAccountData = (state: RootState) =>
  state.accountDataState?.account;
export const selectCreditBalance = (state: RootState) =>
  state.accountDataState?.account?.creditBalance;
export const selectCreditMax = (state: RootState) =>
  state.accountDataState?.account?.creditMax;
export const selectOldStripeData = (state: RootState) =>
  state.accountDataState?.oldStripeData;
